import toCamelCase from '../filters/camel-case'

export default {
  
  props: {
    to: { type: [String, Object] },
    jump: { type: Boolean },
    external: { type: Boolean },
    target: { type: String },
    inAppBrowserTarget: { type: String, default: '_system' },
    activeClass: { type: String },
  },

  computed: {
    hasDestination() {
      return this.to != null
    },

    forceExternal() {
      return this.external
    },

    isExternalDestination() {
      return (this.to && typeof this.to == 'string' && this.to.includes('http') || this.forceExternal)
    },
  },

  methods: {
    click (e) {
      this.hasDestination && this.isExternalDestination && RoutableConfig.externalLinkHandler && RoutableConfig.externalLinkHandler(e, this.inAppBrowserTarget)
      this.$emit('click', e)
    },

    generateRouteLink () {
      const tag = this.hasDestination
        ? (this.isExternalDestination) ? 'a' : 'router-link'
        : this.tag || 'span'

      const data = {
        attrs: {
        },
        class: this.classes,
        style: this.styles,
        props: {
          replace:true
        },
        [(this.hasDestination && !this.isExternalDestination) ? 'nativeOn' : 'on']: {
          ...this.$listeners,
          click: this.click,
        },
      }

      if(this.hasDestination) {
        if(this.isExternalDestination) { // <a>          
          data.attrs.href = this.to
          if(this.target) data.attrs.target = this.target
        }
        // '<router-link>'
        else {
          let destination = typeof this.to == 'string' ? { path: this.to } : this.to // make sure we always work with destination as always an object

          if(this.jump) destination.query = { redirect: this.$route.fullPath, jump: true } // support our "jump" link style navigation

          // Pass some of the $attrs to <router-link> component as props
          data.props.to = destination
          for (let item of ['replace', 'append', 'active-class', 'exact', 'exact-path', 'exact-path-active-class', 'event', 'exact-active-class', 'aria-current']) {
            data.props[toCamelCase(item)] = this.$attrs[item]
          }

          data.props.activeClass = this.activeClass // Add a special activeClass hook for component level styles
          //For some reason if we don't set `exactActiveClass` the `aria-current` property is sometimes not set on the <router-link> component
          data.props.exactActiveClass = this.exactActiveClass || this.activeClass
        }
      }

      return { tag, data }
    }
  }
}

export const RoutableConfig = { externalLinkHandler: null }